import React from 'react';
import { CheckCircle2, BookOpen, Clock, Moon, ShieldCheck, Sparkles } from 'lucide-react';
import { FadeIn } from '../ui/FadeIn';
export function Solution() {
  const deliverables = [{
    icon: <BookOpen className="w-6 h-6 text-brand-sage" data-id="element-156" />,
    title: 'La Guía Maestra',
    desc: 'Las 7 Claves para la Menopausia 40+ (PDF).'
  }, {
    icon: <Clock className="w-6 h-6 text-brand-sage" data-id="element-157" />,
    title: 'El Protocolo Paso a Paso',
    desc: 'El sistema de las 16 Horas para alivio inmediato.'
  }, {
    icon: <ShieldCheck className="w-6 h-6 text-brand-sage" data-id="element-158" />,
    title: 'Lista de Compras',
    desc: "Alimentos que 'apagan' los sofocos y los que los 'encienden'."
  }, {
    icon: <Moon className="w-6 h-6 text-brand-sage" data-id="element-159" />,
    title: 'El Ritual del Magnesio',
    desc: 'Cómo y cuándo usarlo para dormir 8 horas seguidas.'
  }, {
    icon: <CheckCircle2 className="w-6 h-6 text-brand-sage" data-id="element-160" />,
    title: 'Checklist de Emergencia',
    desc: 'Qué hacer exactamente en los despertares nocturnos.'
  }, {
    icon: <Sparkles className="w-6 h-6 text-brand-lavender" data-id="element-161" />,
    title: 'BONO EXCLUSIVO',
    desc: 'Guía de Estiramientos Somáticos de 5 minutos (Sin impacto).'
  }];
  return <section className="py-20 md:py-32 px-4 bg-brand-lavender text-white relative overflow-hidden" data-id="element-162">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-10" data-id="element-163">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-164" />
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-165" />
      </div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-166">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-167">
          <FadeIn data-id="element-168">
            <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-169">
              El Reseteo Térmico de 16 Horas
            </h2>
            <p className="text-xl text-white/90 leading-relaxed" data-id="element-170">
              Es un método exacto que interviene en tu bioquímica desde tu
              última comida de hoy hasta tu primera comida de mañana. Al alinear
              tu cena, tu temperatura corporal y micronutrientes específicos,
              obligas a tu hipotálamo a recalibrarse, permitiendo que tu cuerpo
              se enfríe y tu vientre se desinfle de forma natural.
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.2} data-id="element-171">
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl" data-id="element-172">
            <h3 className="text-2xl md:text-3xl font-bold text-brand-dark text-center mb-10" data-id="element-173">
              ¿Qué obtienes hoy?
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-174">
              {deliverables.map((item, index) => <div key={index} className="flex flex-col items-start p-6 rounded-2xl bg-brand-beige border border-brand-lavenderLight hover:shadow-md transition-shadow" data-id="element-175">
                  <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mb-4 shadow-sm" data-id="element-176">
                    {item.icon}
                  </div>
                  <h4 className="text-lg font-bold text-brand-dark mb-2" data-id="element-177">
                    {item.title}
                  </h4>
                  <p className="text-brand-dark/70" data-id="element-178">{item.desc}</p>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}